import { whyChooseUs } from '@/mocks/homeData';

export default function WhyChooseUs() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-secondary-50 text-secondary-600 text-xs font-semibold rounded-full mb-3">
            Why Choose Happy Faces
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            A Platform Built on{' '}
            <span className="gradient-text">Trust & Transparency</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            We hold ourselves to the highest standards so you can give with complete confidence.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 md:gap-4">
          {whyChooseUs.map((item, index) => (
            <div
              key={index}
              className="group p-5 rounded-2xl bg-background-100 hover:bg-background-50 border border-transparent hover:border-foreground-200/60 transition-all duration-300"
            >
              <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center mb-3 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${item.icon} text-primary-500 text-lg`}></i>
              </div>
              <h4 className="font-heading text-sm font-bold text-foreground-950 mb-1.5">{item.title}</h4>
              <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}